export default __webpack_public_path__ + "static/media/oplaadpuntelektroboten.6020ceba.svg";